export type FormSubmitField = {
  name: string
  label: string
  value: string
}

/** field: どの項目の添付か(履歴書 resume / 職務経歴書 cv / 写真 photo_face・photo_full 等)。GAS 側の仕分け用 */
export type FormSubmitAttachment = { name: string; mimeType: string; data: string; field?: string }

type SubmitFormParams = {
  formType?: 'contact' | 'recruit'
  /** ご用件キー(salon / studio / apprentice / shop / recruit / media / other)。GAS 側が data.topic で宛先を振り分ける(Yuichi 2026-09-17) */
  topic?: string
  fields: FormSubmitField[]
  attachments?: FormSubmitAttachment[]
  lang: string
  page: string
  _hp?: string
}

export async function submitForm({ formType = 'contact', topic = '', fields, attachments = [], lang, page, _hp = '' }: SubmitFormParams): Promise<void> {
  const endpoint = import.meta.env.VITE_QB_FORM_ENDPOINT as string | undefined
  if (!endpoint || !endpoint.startsWith('https://script.google.com/')) {
    throw new Error('ただいまフォームの送信先を確認中でございます。恐れ入りますが、時間をおいて再度お試しくださいませ。')
  }

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain;charset=utf-8' },
    body: JSON.stringify({
      formType,
      topic,
      lang,
      page,
      userAgent: window.navigator.userAgent,
      timestamp: new Date().toISOString(),
      fields,
      attachments,
      _hp,
    }),
  })

  if (!response.ok) {
    throw new Error('フォームを送信できませんでした。')
  }
  const result: unknown = await response.json()
  if (typeof result !== 'object' || result === null || !('status' in result) || result.status !== 'ok') {
    throw new Error('フォームを送信できませんでした。')
  }
}
